import { getDialogRoot } from '@colonist/ui';
import { createDivIn } from '../../ui_utils/DomUtils.ts';
import { mountUIReactComponent } from '../../ui_platform/mountUIReactComponent.tsx';
import { ChangeUsernameDialogContainer } from './ChangeUsernameDialogContainer.tsx';
let nextInstanceId = 0;
export const showChangeUsernameDialog = (continuation)=>{
    const containerId = `change-username-dialog-container-${nextInstanceId}`;
    nextInstanceId += 1;
    const container = createDivIn(getDialogRoot(), '', containerId);
    const view = mountUIReactComponent(containerId, ChangeUsernameDialogContainer);
    let closed = false;
    const onClose = (result)=>{
        if (closed) return;
        closed = true;
        view.unmount();
        container.remove();
        if (continuation == undefined) return;
        switch(result){
            case 'ok':
                if (continuation.triggerOnSuccess) continuation.action();
                return;
            case 'cancelled':
                continuation.action();
                return;
            case 'goToStore':
                return;
        }
    };
    view.render({
        onClose: onClose
    });
};
